import { gql } from "apollo-angular";

export const FD = gql`
  fragment FD on FacultyDirectory {
    title
    backgroundColor {
      color
    }
    header
    hTag
    buttonLabel
  }`;
